/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export const inputCriteriaTypeConfiguration: {
    readonly inputTextPlaceholder: string;
    readonly inputAutoCompleteMultiSelectionPlaceholder: string;
} = {
    inputTextPlaceholder: 'Type to filter',
    inputAutoCompleteMultiSelectionPlaceholder: 'Search for'
};
